import styled from "styled-components";

export const JBOptInReminderContentDefaultBox = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: center;
    height: 200px;
    padding: 5px 24px 24px 24px;
`;


